
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Lead } from '@/types';

@Component
export default class LeadCancelDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('LeadCancelDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  async onCancel() {
    console.log('LeadCancelDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onCancelLead() {
    console.log('LeadCancelDialog: onResolve()'); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('cancelLead');

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
